import { useEffect } from 'react';

interface IProps {
    title: string;
}

const BrowserTitle = ({ title }: IProps) => {
    useEffect(init, [title]);

    function init() {
        document.title = `${title} | Enerzee`;
    }
    return null;
};

export default BrowserTitle;